var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBonhommeAutomobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "140 58.2 360.83 69.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n        .cls-1{\r\n            fill: #fff;\r\n        }\r\n        .cls-2{\r\n            fill: #222424;\r\n        }\r\n        .cls-7 {\r\n            fill: #2da3d1;\r\n        }\r\n     ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_488",
    "data-name": "Grupo 488",
    transform: "translate(14109 15219.196)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_188-3",
    "data-name": "Trazado 188",
    className: "cls-2",
    d: "M70.036,26.737a5.415,5.415,0,0,0,1.589-3.992V20.486c0-2.89-1.484-6.337-8.559-6.337H42.1V40.722H63.133c7.66,0,8.8-3.971,8.8-6.337V30.806a4.753,4.753,0,0,0-1.9-4.069m-5.141-3.471c0,.516,0,.856-1.829.856H48.83V19.873H63.066c1.829,0,1.829.34,1.829.856ZM48.83,29.845h14.3c2.071,0,2.071.722,2.071,1.03v2.641c0,.841-.151,1.483-2.071,1.483H48.83Z",
    transform: "translate(-13946.41 -15153.408)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_189-3",
    "data-name": "Trazado 189",
    className: "cls-2",
    d: "M88.8,14.149H72.639c-7.6,0-8.736,4.362-8.736,6.962V33.759c0,2.6,1.136,6.962,8.736,6.962H88.8c7.6,0,8.734-4.362,8.734-6.962V21.111c0-2.6-1.134-6.962-8.734-6.962M70.635,21.076c0-.419,0-1.2,2-1.2H88.8c2,0,2,.784,2,1.2V33.795c0,.421,0,1.2-2,1.2H72.639c-2,0-2-.784-2-1.2Z",
    transform: "translate(-13934.71 -15153.408)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_190-3",
    "data-name": "Trazado 190",
    className: "cls-2",
    d: "M116.637,31.276,93.682,14.15h-5.4V40.721h6.14V22.7l24.7,18.021h3.659V14.15h-6.14Z",
    transform: "translate(-13921.628 -15153.409)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_191-3",
    "data-name": "Trazado 191",
    className: "cls-2",
    d: "M137.973,23.879h-17.9v-9.73h-6.732V40.722h6.732V29.6h17.9V40.722H144.7V14.149h-6.732Z",
    transform: "translate(-13908.183 -15153.406)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_192-3",
    "data-name": "Trazado 192",
    className: "cls-2",
    d: "M161.137,14.149H144.98c-7.6,0-8.736,4.362-8.736,6.962V33.759c0,2.6,1.134,6.962,8.736,6.962h16.157c7.6,0,8.733-4.362,8.733-6.962V21.111c0-2.6-1.134-6.962-8.733-6.962m-18.161,6.927c0-.419,0-1.2,2-1.2h16.157c2,0,2,.784,2,1.2V33.795c0,.421,0,1.2-2,1.2H144.98c-2,0-2-.784-2-1.2Z",
    transform: "translate(-13895.891 -15153.408)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_193-3",
    "data-name": "Trazado 193",
    className: "cls-2",
    d: "M180.507,33.388,166.522,14.15h-5.9V40.721H167V25.805l10.882,14.916h4.86L193.6,25.784V40.721h6.386V14.15h-5.555Z",
    transform: "translate(-13882.81 -15153.409)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_194-3",
    "data-name": "Trazado 194",
    className: "cls-2",
    d: "M208.738,33.388,194.751,14.15h-5.9V40.721h6.383V25.8l10.885,14.917h4.86l10.848-14.937V40.721h6.383V14.15h-5.555Z",
    transform: "translate(-13867.66 -15153.409)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_195-3",
    "data-name": "Trazado 195",
    className: "cls-2",
    d: "M244.347,19.873V14.149H217.078V40.722h27.269V35H223.81V29.6H243.3V23.879H223.81V19.873Z",
    transform: "translate(-13852.513 -15153.408)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_63-2",
    "data-name": "Rect\\xE1ngulo 63",
    className: "cls-7",
    width: 53.652,
    height: 53.651,
    transform: "translate(-13969 -15161)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_196-2",
    "data-name": "Trazado 196",
    className: "cls-1",
    d: "M16.8,17.871a7.129,7.129,0,1,1,7.13-7.125,7.134,7.134,0,0,1-7.13,7.125m0-9.73a2.6,2.6,0,1,0,2.6,2.6,2.605,2.605,0,0,0-2.6-2.6",
    transform: "translate(-13963.811 -15159.063)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_197-2",
    "data-name": "Trazado 197",
    className: "cls-1",
    d: "M25.582,41.1h-12a3.912,3.912,0,0,1-3.909-3.911V17.644a3.912,3.912,0,0,1,3.909-3.909h7.886a8.012,8.012,0,0,1,6.945,12.022,8.063,8.063,0,0,1,5.18,7.125c.006.065.009.132.009.2v.175a1.967,1.967,0,0,1-.017.27,8.064,8.064,0,0,1-8,7.575M14.2,36.575h11.38a3.407,3.407,0,1,0,0-6.812H21.468a2.265,2.265,0,1,1,0-4.53,3.487,3.487,0,1,0,0-6.973H14.2Z",
    transform: "translate(-13963.81 -15153.63)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_198-2",
    "data-name": "Trazado 198",
    className: "cls-2",
    d: "M44.971,45.292h5.917l-.439,2.081H42.1l2.688-12.679h2.434Z",
    transform: "translate(-13946.409 -15142.383)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_199-2",
    "data-name": "Trazado 199",
    className: "cls-2",
    d: "M53.83,44.963h-.051c-.676,1.183-1.978,1.219-3.009,1.219-2.011,0-3.228-.424-2.721-2.824.456-2.13,1.69-2.721,3.888-2.721,1.082,0,2.148.017,2.451,1.014h.068l.238-1.149c.3-1.437.3-1.944-1.472-1.944-.93,0-1.69.085-1.944,1.234h-2.13C49.706,37.2,51.5,37.1,53.526,37.1c2.84,0,3.921.439,3.3,3.414l-1.185,5.561h-2.13Zm-3.651-1.606c-.27,1.251.22,1.371,1.656,1.371,1.132,0,1.978-.1,2.25-1.371.269-1.234-.644-1.268-1.692-1.268-1.082,0-1.944,0-2.214,1.268",
    transform: "translate(-13943.277 -15141.09)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_200-2",
    "data-name": "Trazado 200",
    className: "cls-2",
    d: "M62.162,37.2l-.287,1.285h.068A3.434,3.434,0,0,1,65.035,37.1c1.116,0,2.333.286,2.3,1.572H67.4A3.345,3.345,0,0,1,70.547,37.1c2.3,0,2.89.793,2.417,2.975l-1.268,6H69.565l1.235-5.8c.186-1.117,0-1.557-1.166-1.557-1.726,0-2.216.779-2.554,2.351l-1.065,5h-2.13l1.234-5.8c.186-1.117,0-1.557-1.166-1.557-1.724,0-2.214.779-2.552,2.351l-1.065,5H58.205L60.1,37.2Z",
    transform: "translate(-13937.768 -15141.09)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_201-2",
    "data-name": "Trazado 201",
    className: "cls-2",
    d: "M77.244,41.649c-.728,3.433-1.438,4.533-5.14,4.533s-3.94-1.1-3.212-4.533c.727-3.448,1.437-4.547,5.138-4.547s3.938,1.1,3.213,4.547M71,41.667c-.49,2.366-.456,2.89,1.437,2.89s2.164-.524,2.654-2.89c.524-2.4.473-2.943-1.42-2.943s-2.147.542-2.671,2.943",
    transform: "translate(-13932.21 -15141.092)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_202-2",
    "data-name": "Trazado 202",
    className: "cls-2",
    d: "M77.43,34.694h2.13L78.511,39.68H78.6A3.192,3.192,0,0,1,81.537,38.4c3.044,0,3.044,1.673,2.485,4.276-.575,2.721-1.116,4.8-4.412,4.8-1.251,0-2.18-.272-2.468-1.438h-.068l-.2,1.337h-2.13Zm.439,7.978c-.439,2.113-.727,3.178,1.454,3.178,1.944,0,2.147-1.165,2.571-3.178.472-2.231.135-2.655-1.335-2.655-1.844,0-2.283.762-2.689,2.655",
    transform: "translate(-13928.894 -15142.383)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_203-2",
    "data-name": "Trazado 203",
    className: "cls-2",
    d: "M83.4,47.372H81.268L83.163,38.5h2.13ZM85.715,36.5h-2.13l.372-1.809h2.13Z",
    transform: "translate(-13925.391 -15142.385)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_204-2",
    "data-name": "Trazado 204",
    className: "cls-2",
    d: "M86.137,47.372h-2.13l2.688-12.679h2.131Z",
    transform: "translate(-13923.921 -15142.385)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_205-2",
    "data-name": "Trazado 205",
    className: "cls-2",
    d: "M88.876,47.372H86.745L88.64,38.5h2.13ZM91.192,36.5h-2.13l.372-1.809h2.13Z",
    transform: "translate(-13922.452 -15142.385)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_206-2",
    "data-name": "Trazado 206",
    className: "cls-2",
    d: "M90.17,37.872h1.116l.423-2.013h2.131l-.424,2.013h3.4l-.355,1.623h-3.4L92.1,44.041c-.152.811-.235,1.183.661,1.183,1.2,0,1.268-.947,1.471-1.876H96.1c-.541,2.688-1.388,3.5-3.686,3.5-2.333,0-2.924-.542-2.451-2.79l.963-4.564H89.815Z",
    transform: "translate(-13920.805 -15141.758)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_207-2",
    "data-name": "Trazado 207",
    className: "cls-2",
    d: "M102.584,44.508c-.592,2.787-2.214,2.924-4.75,2.924-3.4,0-3.871-1.082-3.144-4.515.676-3.178,1.486-4.564,5.071-4.564,3.651,0,3.9,1.065,3.093,4.937h-6.1c-.4,1.91-.489,2.517,1.421,2.517,1.183,0,2.011.017,2.282-1.3Zm-1.572-2.571c.389-1.825.135-1.962-1.606-1.962-1.842,0-2.028.39-2.368,1.962Zm1.437-5.782-3.583,1.454-.27-.879,3.4-1.959Z",
    transform: "translate(-13918.346 -15142.342)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_208-2",
    "data-name": "Trazado 208",
    className: "cls-2",
    d: "M111.062,39.622c.237-1.065-.321-1.065-1.454-1.065s-1.91,0-2.164,1.165c-.186.88.034.913,1.876,1,2.079.1,3.974-.051,3.364,2.823-.506,2.4-2.451,2.638-4.7,2.638-2.417,0-4.04,0-3.431-2.892h2.13c-.237,1.285.034,1.437,1.606,1.437,1.268,0,2.011.034,2.265-1.183.169-.778.2-1.166-1.944-1.2-3.247-.051-3.754-.49-3.262-2.755.507-2.434,2.282-2.486,4.564-2.486,1.741,0,3.8.034,3.279,2.52Z",
    transform: "translate(-13912.964 -15141.092)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_209-2",
    "data-name": "Trazado 209",
    className: "cls-2",
    d: "M112.6,47.372h-2.131l1.895-8.874h2.13ZM114.92,36.5h-2.13l.372-1.809h2.13Z",
    transform: "translate(-13909.719 -15142.385)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_210-2",
    "data-name": "Trazado 210",
    className: "cls-2",
    d: "M117.169,37.2l-.287,1.285h.068a3.434,3.434,0,0,1,3.093-1.386c1.116,0,2.333.286,2.3,1.572h.068a3.339,3.339,0,0,1,3.144-1.572c2.3,0,2.89.793,2.417,2.975l-1.268,6h-2.13l1.234-5.8c.186-1.117,0-1.557-1.166-1.557-1.724,0-2.216.779-2.552,2.351l-1.066,5h-2.13l1.234-5.8c.186-1.117,0-1.557-1.166-1.557-1.724,0-2.214.779-2.552,2.351l-1.065,5h-2.131l1.895-8.874Z",
    transform: "translate(-13908.249 -15141.09)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_211-2",
    "data-name": "Trazado 211",
    className: "cls-2",
    d: "M127.283,38.54h.068a3.294,3.294,0,0,1,3.078-1.438c3.3,0,2.958,2.079,2.383,4.8-.559,2.6-1.268,4.278-4.312,4.278-1.082,0-2.18-.2-2.4-1.286h-.086l-1.063,5.022h-2.131L125.527,37.2h2.128Zm3.4,3.362c.421-2.011.71-3.178-1.235-3.178-2.18,0-2.349,1.065-2.789,3.178-.406,1.893-.287,2.655,1.557,2.655,1.471,0,1.978-.424,2.468-2.655",
    transform: "translate(-13903.094 -15141.092)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_212-2",
    "data-name": "Trazado 212",
    className: "cls-2",
    d: "M132.061,47.372h-2.13l2.688-12.679h2.13Z",
    transform: "translate(-13899.277 -15142.385)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_213-2",
    "data-name": "Trazado 213",
    className: "cls-2",
    d: "M134.8,47.372h-2.13l1.893-8.874h2.131Zm2.316-10.87h-2.13l.372-1.809h2.13Z",
    transform: "translate(-13897.808 -15142.385)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_214-2",
    "data-name": "Trazado 214",
    className: "cls-2",
    d: "M142.008,36.316h-.642c-1.438-.051-1.573.541-1.81,1.64l-.1.542h2.164l-.357,1.621H139.1l-1.538,7.253H135.43l1.54-7.253h-1.251l.353-1.621h1.252l.152-.779c.456-2.13,1.149-3.026,3.482-3.026h1.386Zm.861,11.056h-2.13l1.895-8.874h2.13Zm2.317-10.87h-2.131l.372-1.809h2.13Z",
    transform: "translate(-13896.327 -15142.385)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_215-2",
    "data-name": "Trazado 215",
    className: "cls-2",
    d: "M149.816,44.508c-.592,2.787-2.216,2.924-4.751,2.924-3.4,0-3.871-1.082-3.144-4.515.676-3.178,1.487-4.564,5.071-4.564,3.652,0,3.906,1.065,3.095,4.937h-6.1c-.406,1.91-.49,2.517,1.42,2.517,1.183,0,2.011.017,2.282-1.3Zm-1.574-2.571c.389-1.825.135-1.962-1.6-1.962-1.844,0-2.03.39-2.368,1.962Zm1.438-5.782L146.1,37.609l-.27-.879,3.4-1.959Z",
    transform: "translate(-13893.002 -15142.342)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_216-2",
    "data-name": "Trazado 216",
    className: "cls-2",
    d: "M156.111,43.256c-.59,2.787-2.214,2.924-4.75,2.924-3.4,0-3.872-1.082-3.144-4.513.675-3.179,1.487-4.565,5.071-4.565,3.651,0,3.906,1.065,3.093,4.937h-6.1c-.406,1.91-.492,2.518,1.418,2.518,1.185,0,2.013.015,2.283-1.3Zm-1.572-2.571c.389-1.824.135-1.961-1.606-1.961-1.842,0-2.028.39-2.366,1.961Z",
    transform: "translate(-13889.622 -15141.092)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBonhommeAutomobile);
export default __webpack_public_path__ + "static/media/logo-Bonhomme-Automobile.16d9da3121c8549a35ded7b4de4a4666.svg";
export { ForwardRef as ReactComponent };